
import getCmp from "./helpers/cmpHelpers";
jQuery(document).ready(function () {
    const cmp = getCmp();
    if(cmp !== null){
        cmp('addEventListener', ['consent', handleConsent, false], null)
        let consent = __cmp('getCMPData');
        if(consent !== undefined && consent !== null && consent.consentExists !== null && consent.consentExists !== undefined){
            checkHandleModalCookie()
        }
    }
    if(cmp === null){
        checkHandleModalCookie();
    }

});
function handleConsent(e, o){
    checkHandleModalCookie();
}
function checkHandleModalCookie(){
    if (document.cookie.indexOf("ModalShown=true") < 0 && parseInt(wp_environment.show_alerts) > 0) {
        jQuery('#ume-info-modal').modal("show");

        umeCreateCookie('ModalShown', 'true', 1);
        let hash = window.location.hash;
        if(hash !== ''){
            let modal = document.getElementById('ume-info-modal');
            modal.setAttribute('data-has-hash', 'true');
            modal.setAttribute('data-hash', hash);

        }
    }
}
function umeCreateCookie(name, value, days) {
    let expires = '';
    if (days) {
        let d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + d.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
}